<template>
	<div class="tasks" ref="tasks">
		<div
			class="tasks__section tasks__section--week"
			v-for="(week, index) in getTaskWeeks(getFilteredTasks(planning.Tasks))"
			:key="index">
			<div class="tasks__section__header tasks__section__header--week">
				<router-link
					:to="`/week/${week.date.format('Y-m-d')}`"
					tag="div"
					class="tasks__section__header__title tasks__section__header__title--week clickable"
					v-if="userIsOwner">
					Week {{week.week}}<br>
					<span class="tasks__section__header__title__date">{{new Date(week.date).format('d/m -')}} {{new Date(week.end).format('d/m')}}</span>
				</router-link>
				<div class="tasks__week__title"	v-else>
					Week {{week.week}}<br>
					<span class="tasks__section__header__title__date">{{new Date(week.date).format('d/m -')}} {{new Date(week.end).format('d/m')}}</span>
				</div>
			</div>
			<div class="tasks__section__content tasks__section__content--week">
				<Task
					v-for="task in getTasks(week)"
					:key="task.id"
					:task="task"
					:topic="planning.Topics[task.topicIndex]">
				</Task>
			</div>
		</div>
	</div>
</template>

<script>
import DateService from '@/services/DateService'
import PlanningService from '@/services/PlanningService'
import { tasks } from '@/components/mixins/tasks'
export default {
	mixins: [tasks],
	props: {
		filters: Object,
		planning: Object
	},
	data () {
		return {
		}
	},
	methods: {
		getTaskWeeks (tasks) {
			return DateService.getTaskWeeks(tasks)
		},
		getFilteredTasks (tasks) {
			if (!this.filters) return tasks
			var filteredTasks = []
			if (this.filters.type === 'topic') {
				const topicIndex = this.filters.key
				filteredTasks = tasks.filter(function (task) {
					return task.topicIndex === topicIndex
				})
			} else if (this.filters.type === 'type') {
				const type = this.filters.key
				filteredTasks = tasks.filter(function (task) {
					return task.type === type
				})
			} else if (this.filters.type === 'month') {
				const month = this.filters.key
				filteredTasks = PlanningService.getMonthTasks(month, tasks)
			}
			return filteredTasks
		},
		getTasks (week) {
			const tasks = this.getWeekTasks(week, this.getFilteredTasks(this.planning.Tasks))
			tasks.forEach(task => { task.planningId = this.planning.id })
			return tasks
		}
	},
	computed: {
		userIsOwner () {
			return this.planning.User.id === this.$store.state.authentication.user.id
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_tasks.scss"
</style>
